export default __webpack_public_path__ + "static/media/htbabyImg2.0f3bc487.png";